/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import './css/plugins.css';
import './css/style.css';
import './css/templete.css';
import './css/skin/skin-1.css';
import './css/customstyle.css';
import './css/packages.css';
import './plugins/slick/slick.min.css';
import './plugins/slick/slick-theme.min.css';

import Header from './views/Layout/Header';
import Footer from './views/Layout/Footer';
import withClearCache from "./ClearCache.js";

import PublicDashboard from './views/Pages/Public/Dashboard';
import Login from './views/Pages/User/Loginpage2';
import Dashboard from './views/Pages/Homepage2';
import JOCLayout from './views/Pages/JOC/Layout';
import IndividualCandidate from './views/Pages/Employer/Jobs/PostedJobsandAppliedCandidates/IndividualCandidate';
import ConCanCVs from './views/Pages/PDFs/ConCanCVs';
import Jobdetail from './views/Pages/Jobs/Jobdetail';
import SignUp from './views/Pages/User/Register2';

import CanDashboard from './views/Pages/Homepage1';
import CanLayout from './views/Pages/Candidate/Layout';

import EmpLayout from './views/Pages/Employer/Layout';
import Browsejoblist from './views/Pages/Public/Dashboard/Browsejoblist';
import ScrollButton from './components/ScrollButton';
import Error404 from './views/Pages/Error404';
import Temp from './views/temp';
import VerifyOtp from './views/Pages/User/VerifyOtp';

// const PublicDashboard = lazy(() => import('./views/Pages/Public/Dashboard'))
// const Login = lazy(() => import('./views/Pages/User/Loginpage2'))

const ClearCacheComponent = withClearCache(MainApp);

function App() {
    return <ClearCacheComponent />;
}

function MainApp() {

    return (
        <>
            <Header />
            <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                    <Route path='/' exact name='PublicDashboard' component={PublicDashboard} />
                    <Route path='/login' name='Login' component={Login} />
                    <Route path='/register' name='Login' component={SignUp} />
                    <Route path='/verify-otp/:data?' name='VerifyOtp' component={VerifyOtp} />
                    <Route path='/browse-job-list/:filter?' exact name='Browsejoblist' component={Browsejoblist} />
                    <Route path='/emp-candidate/:id?/:purl?' exact name='IndividualCandidate' component={IndividualCandidate} />
                    <Route path='/candidate-cv/:id?' exact name='CandidateCV' component={ConCanCVs} />
                    <Route path='/job-detail/:jobId?' exact name='Jobdetail' component={Jobdetail} />

                    <Route path='/joc' exact name='JocDashboard' component={Dashboard} />
                    <Route path='/joc/:path?/:id?/:vac?' exact> <JOCLayout /> </Route>

                    <Route path='/candidate' exact name='StuDashboard' component={CanDashboard} />
                    <Route path='/candidate/:path?/:id?' exact> <CanLayout /> </Route>

                    <Route path='/employer' exact name='EmpDashboard' component={Dashboard} />
                    <Route path='/employer/:path?/:id?' exact> <EmpLayout /> </Route>

                    <Route path='/demo' exact name='Demo' component={Temp} />

                    <Route path="*" component={Error404} />
                </Switch>
            </Suspense>
            <ScrollButton />
            <Footer />
        </>
    );
};


export default App;
